import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import Form, { FormProps } from '@/components/Form';

import { FolderEditorFormValues, FORM_LAYOUT, getFormFields, INITIAL_VALUES } from './config';

function Editor({
  setFormikSubmit,
  onSubmit,
}: {
  setFormikSubmit: FormProps<FolderEditorFormValues>['setSubmitRef'];
  onSubmit: FormProps<FolderEditorFormValues>['onSubmit'];
}) {
  const { t } = useTranslation();

  return (
    <Form
      fields={getFormFields(t)}
      formName="FolderEditor"
      initialValues={INITIAL_VALUES}
      // sectionLayout={getFormLayout(t)}
      layout={FORM_LAYOUT}
      setSubmitRef={setFormikSubmit}
      onSubmit={onSubmit}
    />
  );
}

export default Editor;
